import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { Store } from '@ngrx/store';
import * as selectors from './dashboard/state';
import { distinctUntilChanged } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CookiesBannerComponent } from './core/cookies/cookies-banner/cookies-banner.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CookiesBannerComponent, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private viewContainerRef = inject(ViewContainerRef);
  private auth = inject(AuthService);
  private store = inject(Store);

  title = 'UnderstandingDyslexia';
  _destroy: DestroyRef = inject(DestroyRef);

  isAuthenticated$ = this.auth.isAuthenticated$;

  ngOnInit(): void {
    const windowCurrentPath = window.location.pathname;

    if (!windowCurrentPath.includes('logout')) {
      this.auth.login();
    }

    this.isAuthenticated$
      .pipe(takeUntilDestroyed(this._destroy), distinctUntilChanged())
      .subscribe((isAuthenticated) => {
        if (isAuthenticated)
          this.store.dispatch(selectors.DashboardPageActions.initApp());
      });

    setTimeout(async () => {
      const { LazySvgSpriteSheetComponent } = await import(
        './core/lazy-svg-sprite-sheet/lazy-svg-sprite-sheet.component'
      );
      this.viewContainerRef.createComponent(LazySvgSpriteSheetComponent);
    });
  }
}
